const getModuleState = state => state.layout

export const isNavOpen = state => getModuleState(state).isNavOpen
